import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-private',
  templateUrl: './footer-private.component.html',
  styleUrls: ['./footer-private.component.css']
})
export class FooterPrivateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
